// extracted by mini-css-extract-plugin
export default {"badge":"CurrencyBadge_badge__JVJOA","brand":"CurrencyBadge_brand__xkQM3","subtle":"CurrencyBadge_subtle__kzlP4"};